/**
 * Identity lives entirely in localStorage (§5). The token is the sole credential
 * and doubles as the recovery code. No accounts, no passwords, no email.
 */

const KEY = 'panels:identity';

export interface Identity {
  playerId: string;
  token: string;
  displayName: string;
}

let cached: Identity | null | undefined;

export function readIdentity(): Identity | null {
  if (cached !== undefined) return cached;
  try {
    const raw = localStorage.getItem(KEY);
    cached = raw ? (JSON.parse(raw) as Identity) : null;
  } catch {
    cached = null;
  }
  return cached;
}

export function writeIdentity(identity: Identity): void {
  cached = identity;
  localStorage.setItem(KEY, JSON.stringify(identity));
}

export function updateDisplayName(displayName: string): void {
  const current = readIdentity();
  if (current) writeIdentity({ ...current, displayName });
}

export function clearIdentity(): void {
  cached = null;
  localStorage.removeItem(KEY);
}

/**
 * The recovery code IS the token. It is base64url, so it can legitimately contain
 * "-" and "_" — never chunk or prettify it, or you corrupt the credential. Only
 * surrounding whitespace is stripped on the way back in.
 */
export function parseRecoveryCode(input: string): string {
  return input.trim();
}
